import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import Inputs from "../../../components/Input/Input";
import { Row as Rows } from "react-styled-flexboxgrid";

const SettingsForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const HeadingSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 25px;
`;

const Title = styled.h3`
  font-family: "Poppins", sans-serif;
  font-size: ${themeGet("fontSizes.4", "21")}px;
  font-weight: ${themeGet("fontWeights.6", "700")};
  color: ${themeGet("colors.darkBold", "#0D1136")};
`;

const SettingsFormContent = styled.div`
  margin-bottom: 50px;
  .card {
  width: 100%;
  height: auto;
  min-height: 221px;
  border-radius: 5px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.2);
  background-color: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-grid {
  display: grid;
  grid-template-columns: auto 1px 1fr;
  gap: 40px;
  align-items: center;
  
}

.co-img img {
  width: 100px;
  height: 100px;
}

.vertical {
  width: 1px;
  border-left: 5px dotted black;
  height: 100%;
}

.content h1 {
  font-size: 24px;
  color: #565656;
}

.content h1 span {
  font-size: 14px;
}

.content h2 {
  font-size: 16px;
  color: #565656;
  text-transform: uppercase;
}

.content p {
  font-size: 14px;
  color: #696969;
}

.copy-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.input-wrapper {
  position: relative;
  flex: 1;
}

  .see-more-btn {
    background: none;
    border: none;
    color: #007bff; /* Bootstrap primary color */
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    margin-top: 5px;
    padding: 0;
    text-decoration: underline;
  }

  .see-more-btn:hover {
    color: #0056b3; /* Darker shade for hover effect */
    text-decoration: none;
  }

  .coupon-input {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  background: none;
  color: transparent;
}

.copy-button input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 15px;
  }
  .input-wrapper {
    position: relative;
    display: inline-block;
  }

  .coupon-input {
    position: relative;
    color: transparent; /* Hide original value */
    background: none;
    z-index: 2;
  }

  .coupon-input:focus + .blurred-text {
    filter: blur(0); /* Remove blur on focus */
  }
  .copy-button button {
    padding: 5px 20px;
    background-color: #9cc54b;
    color: #fff;
    border: 1px solid transparent;
  }
.blurred-text {
  position: absolute;
  top: 0;
  left: 25%;
  width: 100%;
  height: 100%;
  color: black;
  display: flex;
  align-items: flex-start;
  //justify-content: ;
  //filter: blur(4px);
  pointer-events: none;
}

  .copybtn {
    padding: 5px 10px;
    background-color: #dc143c;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .card-grid {
      grid-template-columns: 1fr;
      text-align: center;
    }

    .vertical {
      display: none;
    }

    .co-img img {
      margin: 0 auto;
    }
  }


  .buy{
  position: absolute;
    content: "";
    bottom: 20px;
    left:20px;
    background-color: #dc143c;
  }
  &:last-child {
    margin-bottom: 0;
  }
  .tabProfile {
    border-bottom: 1px solid #ddd !important;
    justify-content: center;
    margin-bottom: 20px;
  }
  .react-switch {
    &.active {
      .react-switch-bg {
        background: #9cc54b !important;
      }
    }
  }

  ${({ isOpen }) =>
        isOpen &&
        `
    &::after {
      transform: translateY(-50%) rotate(180deg);
    }
  `}
`;

const Input = styled(Inputs)`
  @media only screen and (min-width: 0em) and (max-width: 47.99em) {
    margin-bottom: 30px;
  }
`;

const Row = styled(Rows)`
  margin-bottom: 40px;

  @media only screen and (min-width: 0em) and (max-width: 47.99em) {
    margin-bottom: 30px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;

  .radioGroup {
    flex-grow: 1;
    justify-content: space-between;

    label {
      margin-top: 0;
      flex: calc(33.333333333% - 10px);
      max-width: calc(33.333333333% - 10px);
      margin-bottom: 15px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      @media (max-width: 700px) {
        flex: calc(50% - 10px);
        max-width: calc(50% - 10px);

        &:nth-child(3n) {
          margin-right: 15px;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }
      }

      @media (max-width: 480px) {
        flex: 100%;
        max-width: 100%;
        margin-right: 0;

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }

  .reusecore__button {
    flex: calc(33.3333333333% - 10px);
    max-width: calc(33.3333333333% - 10px);
    flex-shrink: 0;
    height: auto;
    min-height: 77px;
    border: 1px dashed ${themeGet("colors.borderColor", "#f1f1f1")};
    margin-bottom: 15px;
    margin-left: 0;
    margin-right: auto;
    &:hover {
      border-color: ${themeGet("colors.primary", "#9cc54b")};
    }

    @media (max-width: 700px) {
      flex: calc(50% - 10px);
      max-width: calc(50% - 10px);
    }

    @media (max-width: 480px) {
      flex: 100%;
      max-width: 100%;
    }
  }
`;

///
const PaymentGroupButton = styled.div`
  display: flex;

  .radioGroup {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 20px;
    @media (min-width: 120px) {
      grid-template-columns: repeat(1, 1fr);
    }
    @media (min-width: 320px) {
      grid-template-columns: repeat(1, 1fr);
    }
    @media (min-width: 420px) {
      grid-template-columns: repeat(1, 1fr);
    }

    @media (min-width: 600px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 900px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;
export {
  SettingsForm,
  HeadingSection,
  Title,
  SettingsFormContent,
  Input,
  Row,
  ButtonGroup,
  PaymentGroupButton,
};
